<pk-poker-publicpage-promotions *ngIf="!initData.isPokerPromotionSynopsis" [initData]="initData"></pk-poker-publicpage-promotions>
<pk-poker-synopsis-publicpage-promotions *ngIf="initData.isPokerPromotionSynopsis" [initData]="initData"></pk-poker-synopsis-publicpage-promotions>
